import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';
import * as ProfileActions from './profile.actions';
import * as ProfileSelectors from './profile.selectors';

@Injectable({
  providedIn: 'root',
})
export class ProfileFacade {
  profile$ = this._store.pipe(
    select(ProfileSelectors.getProfile),
    filter(profile => !!profile)
  );
  error$ = this._store.pipe(
    select(ProfileSelectors.getProfileError),
    filter(error => !!error)
  );
  loaded$ = this._store.pipe(
    select(ProfileSelectors.getLoaded),
    filter(loaded => !!loaded)
  );
  userInfo$ = this._store.pipe(
    select(ProfileSelectors.getUserInfo),
    filter(userInfo => !!userInfo)
  );
  removeProfile$ = this._store.pipe(select(ProfileSelectors.getLogout));

  constructor(private _store: Store) {}

  loadProfile(authProfile: any) {
    this._store.dispatch(ProfileActions.loadProfile({ authProfile }));
  }

  loadProfileFailure(error: string) {
    this._store.dispatch(ProfileActions.loadProfileFailure({ error: { message: error }}));
  }

  loadAuth() {
    this._store.dispatch(ProfileActions.auth());
  }

  loadAuthSuccess() {
    this._store.dispatch(ProfileActions.authSuccess());
  }

  loadAuthFailure(error: string) {
    this._store.dispatch(ProfileActions.authFailure({ error: { message: error }}));
  }

  notFound(error: string) {
    this._store.dispatch(ProfileActions.pageNotFound({ error: { message: error }}));
  }

  removeProfile() {
    this._store.dispatch(ProfileActions.removeProfile());
  }
}
